export enum EXCEPTION_CODES {
  FORMAT_ERROR = 'FORMAT_ERROR',
  NOT_AUTHENTICATED = 'NOT_AUTHENTICATED',
  ENTITY_NOT_FOUND = 'ENTITY_NOT_FOUND',
  ENTITY_NOT_UNIQUE = 'ENTITY_NOT_UNIQUE',
  CODE_VERIFICATION_FAILED = 'CODE_VERIFICATION_FAILED',
  SERVER_ERROR = 'SERVER_ERROR',
  TOO_MANY_REQUESTS = 'TOO_MANY_REQUESTS',
  MAX_CHECK_ATTEMPTS_REACHED = 'MAX_CHECK_ATTEMPTS_REACHED',
  TWILIO_MAX_SEND_ATTEMPTS_REACHED = 'TWILIO_MAX_SEND_ATTEMPTS_REACHED',
  TWILIO_TEMPORARELY_BLOCKED = 'TWILIO_TEMPORARELY_BLOCKED',
  TWILIO_INVALID_PHONE_NUMBER = 'TWILIO_INVALID_PHONE_NUMBER',
  CODE_INVALID = 'CODE_INVALID',
  ERR_NETWORK = 'ERR_NETWORK',
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  VALIDATION_EXCEPTION = 'VALIDATION_EXCEPTION',
  USER_NOT_UNIQUE = 'USER_NOT_UNIQUE',
  PLAID_LINK_TOKEN_ERROR = 'PLAID_LINK_TOKEN_ERROR',
  SURVEY_NOT_FOUND = 'SURVEY_NOT_FOUND',
  SURVEY_NOT_UNIQUE = 'SURVEY_NOT_UNIQUE',
  REWARD_NOT_UNIQUE = 'REWARD_NOT_UNIQUE',
  PLAID_TOKEN_EXCHANGE_ERROR = 'PLAID_TOKEN_EXCHANGE_ERROR',
  SURVEYANSWER_NOT_UNIQUE = 'SURVEYANSWER_NOT_UNIQUE',
  COLLECTIONSHARE_NOT_FOUND = 'COLLECTIONSHARE_NOT_FOUND',
}

export enum EXCEPTION_FIELD_CODES {
  'string.empty' = 'Invalid value',
  'string.phone.country' = 'string.phone.country',
  'string.phone.format' = 'string.phone.format',
}
